<template>
    <div class="augmented-reality-btn">
        <v-hover v-slot="{ hover }">
            <v-row
                class="d-flex"
                dense
            >
                    <ArTooltip :hover="hover"/>
                    <ArButton/>
            </v-row>
        </v-hover>
    </div>
</template>

<script>
    import ArButton from '@/components/augmentedReality/components/ArButton';
    import ArTooltip from '@/components/augmentedReality/components/ArTooltip';

    export default {
        name: 'AugmentedReality',
        components: {
            ArTooltip,
            ArButton
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/augmentedReality/AugmentedReality.vue